export default __webpack_public_path__ + "static/media/round-reversed.e1386c1d.svg";